export default __webpack_public_path__ + "static/media/separator.48bc3da7.png";